import React, { useCallback, useEffect, useState } from 'react';
import Image from 'next/image';

import clsx from 'clsx';

import PropTypes from 'prop-types';

// Components
import Icon from '@/components/base/Icon';
import { MODAL_DIALOG_CLASSNAME } from '@/components/base/Modal';

const MediaLibraryViewerNavigation = ({ media, className, isNext, navAction, modalParent }) => {
    const keyNavAction = useCallback(
        (e) => {
            const openedModals = document.getElementsByClassName(MODAL_DIALOG_CLASSNAME);
            const noModalAbove =
                openedModals?.length <= 1 ||
                openedModals?.item(openedModals?.length - 1)?.id === modalParent?.current?.id;
            if (
                ((e.key === 'ArrowLeft' && !isNext) || (e.key === 'ArrowRight' && isNext)) &&
                e.target.nodeName !== 'TEXTAREA' &&
                noModalAbove
            ) {
                navAction();
            }
        },
        [isNext, navAction, modalParent]
    );
    useEffect(() => {
        document.addEventListener('keydown', keyNavAction);

        return () => {
            document.removeEventListener('keydown', keyNavAction);
        };
    }, [keyNavAction]);

    return (
        <button
            onClick={navAction}
            data-testid={`mlv-nav-${isNext ? 'next' : 'prev'}`}
            className={clsx(
                'fixed top-1/2 z-10 h-[3.25rem] w-[3.25rem] transform cursor-pointer overflow-hidden rounded-lg border-2 border-white bg-icoGray-100 transition-transform duration-300 dark:border-icoDarkMode-anthracite dark:bg-icoDarkMode-deepBlack md:h-[6.5rem] md:w-[6.5rem]',
                {
                    '-left-6 hover:translate-x-1/4 md:-left-12': !isNext,
                    '-right-6 hover:-translate-x-1/4 md:-right-12': isNext
                },
                className
            )}>
            <div className="relative h-full w-full">
                <Img
                    src={
                        media?.medias?.[0]?.min_thumbnail ??
                        media?.medias?.[0]?.thumbnail ??
                        media?.medias?.[0]?.image
                    }
                    postId={media.id}
                />
            </div>
        </button>
    );
};

const Img = ({ postId, src }) => {
    const [errorImg, setErrorImage] = useState(false);

    return !errorImg && src ? (
        <Image
            src={src}
            alt={postId}
            fill
            className="h-full w-full object-cover"
            onError={() => setErrorImage(true)}
            sizes="
              20vw"
        />
    ) : (
        <div className="flex h-full w-full items-center justify-center bg-icoGray-300 dark:bg-icoDarkMode-deepBlack">
            {/* Change Icon to real fallback */}
            <Icon icon="content" className="text-2xl text-icoGray-500 dark:text-icoDarkMode-wolf" />
        </div>
    );
};

Img.propTypes = {
    postId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    media: PropTypes.string
};

export default MediaLibraryViewerNavigation;
